module.exports = __webpack_public_path__ + "fonts/manifest-heavy-webfont.154fd2d.woff";